export default __webpack_public_path__ + "static/hero-bg-mobile-dcd9ac18ddeda9477203e18398d3b83f.jpg";